<template>
  <div class="content">
    <div id="md-hddb2"></div>
    <!-- <img class="content-info" src="../../assets/img/bonus/bonus1.png" /> -->
    <div style="padding: 0 3% 15%">
      <div
        v-for="(item, index) in bonusData"
        :key="index + 'a'"
        @click="goDetail(index)"
        style="
          /* background: #e9f9f9; */
          border-radius: 13px;
          /* box-shadow: 0 0px 1px 1px rgba(0, 0, 0, 0.1); */
        "
      >
        <div
          class="content-info2--img"
          :style="`background-image: url(${item.img});`"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              flex-flow: column;
              height: 100%;
              padding: 20px 0 10px 20px;
            "
          >
            <div>
              <p
                style="font-size: var(--vk-fs-15); font-weight: 800; line-height: 15px"
                class="m-b-10"
                v-safe-html.rich="item.tex1"
              ></p>
              <p style="color: #677186" v-safe-html.rich="item.text2"></p>
            </div>
            <div class="d-flex">
              <img :src="item.img2" width="33" />
              <p class="m-l-10 f-w" style="color: #acb3ca">{{ item.name }}</p>
            </div>
          </div>
          <!-- <van-button size="large" class="popup-button1">Detalhes </van-button> -->
        </div>
        <!-- <div
          class="d-flex f-t-15 f-w"
          style="justify-content: space-between; padding: 3%"
        >
          <div class="d-flex">
            <img :src="item.img2" width="33" class="m-r-10" />
            <p style="color: rgba(0, 0, 0, 0.85)">{{ item.name }}</p>
          </div>
          <p
            style="
              background: #1d567d;
              padding: 10px 7px;
              border-radius: 8px;
              color: #ffffff;
            "
          >
            {{ $lang.common_txt6 }}
          </p>
        </div> -->
      </div>
    </div>

    <lucky-roulette v-model="showPopup" overlay></lucky-roulette>
    <login v-model="showLogin" overlay></login>
  </div>
</template>
<script>
import { GetPromoRule } from '@/api/common'
import { hasUnavailableMarker, isReadableOkResponse as isRewardReadableOkResponse, responseContent } from '@/views/details/activity/rewardApi'
import { isActivityVisible } from '@/views/layout/activityVisibility'
import { isReadableOkResponse, safeArray, safeContent, safeObject, safeString } from '@/views/layout/safeLayout'

const PROMO_RULE_LIST_KEYS = ['promoRuleList', 'ruleList', 'activityList', 'list', 'dataList', 'records', 'items']
const PROMO_ENVELOPE_KEYS = ['content', 'payload', 'extra', 'page', 'data', 'body']
const MAX_PROMO_ENVELOPE_DEPTH = 8
const BONUS_BACKEND_UNAVAILABLE_MESSAGE = 'This activity is temporarily unavailable. Please try again later.'
const BONUS_ROUTE_UNAVAILABLE_MESSAGE = 'This activity is temporarily unavailable. Please try again later.'

function getBonusAnchorElement() {
  try {
    if (typeof document === 'undefined' || !document || typeof document.getElementById !== 'function') return null
    const target = document.getElementById('md-hddb2')
    if (!target || typeof target.scrollIntoView !== 'function') return null
    return target
  } catch (e) {
    return null
  }
}

const HIDDEN_TOKENS = [
  '1',
  'true',
  'yes',
  'delete',
  'deleted',
  'hidden',
  'mock',
  'mock_mode',
  'mock-mode',
  'mock mode',
  'mock_fallback',
  'mock-fallback',
  'mock fallback',
  'fallback',
  'fallback_used',
  'fallback used',
  'data_unavailable',
  'dataunavailable',
  'data unavailable',
  'read_only',
  'read_only_mode',
  'read_only_query',
  'readonly',
  'readonly_mode',
  'readonlymode',
  'readonly_query',
  'read only',
  'read only mode',
  'read only query',
  'read-only',
  'read-only-mode',
  'read-only-query',
  'read_only_action',
  'read only action',
  'read-only-action',
  'read_failure',
  'read failure',
  'read-failure',
  'read_failed',
  'read failed',
  'read-failed',
  'readfailed',
  'read_unavailable',
  'read unavailable',
  'read-unavailable',
  'readunavailable',
  'missing_table',
  'missing table',
  'missing-table',
  'missingtable',
  'missing_column',
  'missing column',
  'missing-column',
  'missingcolumn',
  'unimplemented',
  'not_implemented',
  'not implemented',
  'not_supported',
  'not supported',
  'unsupported',
  'write_blocked',
  'writeblocked',
  'write blocked',
  'write-blocked',
  'blocked',
  'backend_blocked',
  'backendblocked',
  'backend blocked',
  'backend-blocked',
  'backend_failure',
  'backendfailure',
  'backend failure',
  'backend-failure',
  'technical_marker',
  'technicalmarker',
  'technical marker',
  'technical-marker'
]
const SHOW_BLOCK_TOKENS = ['0', 'false', 'no', 'hidden', 'off', 'closed', 'disabled']

function normalizedPromoToken(value) {
  return safeString(value).trim().toLowerCase()
}

function isHiddenPromoMarker(value) {
  const token = normalizedPromoToken(value)
  return value === true || HIDDEN_TOKENS.includes(token) || (
    token &&
    (
      token.includes('mock') ||
      token.includes('fallback') ||
      token.includes('data_unavailable') ||
      token.includes('dataunavailable') ||
      token.includes('data unavailable') ||
      token.includes('read_only') ||
      token.includes('read_only_mode') ||
      token.includes('read_only_query') ||
      token.includes('read_only_action') ||
      token.includes('read_failure') ||
      token.includes('read_failed') ||
      token.includes('read_unavailable') ||
      token.includes('readunavailable') ||
      token.includes('read unavailable') ||
      token.includes('read-unavailable') ||
      token.includes('missing_table') ||
      token.includes('missingtable') ||
      token.includes('missing table') ||
      token.includes('missing-column') ||
      token.includes('missing_column') ||
      token.includes('missingcolumn') ||
      token.includes('missing column') ||
      token.includes('read only') ||
      token.includes('read only mode') ||
      token.includes('read only query') ||
      token.includes('read only action') ||
      token.includes('read failure') ||
      token.includes('read failed') ||
      token.includes('read-only') ||
      token.includes('read-only-mode') ||
      token.includes('read-only-query') ||
      token.includes('read-only-action') ||
      token.includes('read-failure') ||
      token.includes('read-failed') ||
      token.includes('readfailed') ||
      token.includes('readonly_mode') ||
      token.includes('readonlymode') ||
      token.includes('readonly_query') ||
      token.includes('readonlyquery') ||
      token.includes('unimplemented') ||
      token.includes('not_implemented') ||
      token.includes('not implemented') ||
      token.includes('not_supported') ||
      token.includes('not supported') ||
      token.includes('unsupported') ||
      token.includes('write_blocked') ||
      token.includes('writeblocked') ||
      token.includes('write blocked') ||
      token.includes('write-blocked') ||
      token.includes('backend_blocked') ||
      token.includes('backendblocked') ||
      token.includes('backend blocked') ||
      token.includes('backend-blocked') ||
      token.includes('backend_failure') ||
      token.includes('backendfailure') ||
      token.includes('backend failure') ||
      token.includes('backend-failure') ||
      token.includes('technical_marker') ||
      token.includes('technicalmarker') ||
      token.includes('technical marker') ||
      token.includes('technical-marker') ||
      token === 'blocked'
    )
  )
}

function isUnavailablePromoToken(value) {
  const token = normalizedPromoToken(value)
  return !!token && (
    token.includes('mock') ||
    token.includes('fallback') ||
    token.includes('data_unavailable') ||
    token.includes('dataunavailable') ||
    token.includes('data unavailable') ||
    token.includes('read_only') ||
    token.includes('read_only_mode') ||
    token.includes('read_only_query') ||
    token.includes('read_only_action') ||
    token.includes('read_failure') ||
    token.includes('read_failed') ||
    token.includes('read_unavailable') ||
    token.includes('readunavailable') ||
    token.includes('read unavailable') ||
    token.includes('read-unavailable') ||
    token.includes('missing_table') ||
    token.includes('missingtable') ||
    token.includes('missing table') ||
    token.includes('missing-column') ||
    token.includes('missing_column') ||
    token.includes('missingcolumn') ||
    token.includes('missing column') ||
    token.includes('read only') ||
    token.includes('read only mode') ||
    token.includes('read only query') ||
    token.includes('read only action') ||
    token.includes('read failure') ||
    token.includes('read failed') ||
    token.includes('read-only') ||
    token.includes('read-only-mode') ||
    token.includes('read-only-query') ||
    token.includes('read-only-action') ||
    token.includes('read-failure') ||
    token.includes('read-failed') ||
    token.includes('readfailed') ||
    token.includes('readonly_mode') ||
    token.includes('readonlymode') ||
    token.includes('readonly_query') ||
    token.includes('readonlyquery') ||
    token.includes('unimplemented') ||
    token.includes('not_implemented') ||
    token.includes('not implemented') ||
    token.includes('not_supported') ||
    token.includes('not supported') ||
    token.includes('unsupported') ||
    token.includes('write_blocked') ||
    token.includes('writeblocked') ||
    token.includes('write blocked') ||
    token.includes('write-blocked') ||
    token.includes('backend_blocked') ||
    token.includes('backendblocked') ||
    token.includes('backend blocked') ||
    token.includes('backend-blocked') ||
    token.includes('backend_failure') ||
    token.includes('backendfailure') ||
    token.includes('backend failure') ||
    token.includes('backend-failure') ||
    token.includes('technical_marker') ||
    token.includes('technicalmarker') ||
    token.includes('technical marker') ||
    token.includes('technical-marker') ||
    token === 'blocked'
  )
}

function bonusPayload(error) {
  if (!error || typeof error !== 'object') return error
  if (error.response && typeof error.response === 'object' && error.response.data !== undefined) return error.response.data
  return error
}

function isBonusReadUnavailable(error) {
  const payload = bonusPayload(error)
  return hasUnavailableMarker(payload) || hasUnavailableMarker(responseContent(payload))
}

function isShowBlocked(value) {
  return value === false || SHOW_BLOCK_TOKENS.includes(normalizedPromoToken(value))
}

function promoFailureMessage(source, fallback) {
  const stack = [source]
  for (let i = 0; i < stack.length && i < 50; i++) {
    const body = stack[i]
    if (!body || typeof body !== 'object') continue
    const message = [
      body.msg,
      body.message,
      body.errorMsg,
      body.errorMessage,
      body.reason,
      body.desc,
      body.description
    ].find(value => safeString(value).trim())
    if (message) return safeString(message, fallback)
    for (const key of PROMO_ENVELOPE_KEYS) {
      const value = body[key]
      if (value && typeof value === 'object') stack.push(value)
    }
  }
  return fallback
}

function collectPromoRules(source, depth = 0, out = [], seen = new Set()) {
  if (!source || typeof source !== 'object' || depth >= MAX_PROMO_ENVELOPE_DEPTH || seen.has(source)) return out
  seen.add(source)
  for (const key of PROMO_RULE_LIST_KEYS) {
    safeArray(source[key]).forEach(rule => out.push(rule))
  }
  for (const key of PROMO_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || typeof value !== 'object') continue
    collectPromoRules(value, depth + 1, out, seen)
  }
  return out
}

export default {
  name: 'bonus',
  components: {},
  data() {
    const fallbackUnavailable = {
      readOnly: true,
      unavailableReason: 'backend_rules_absent',
      unavailableMessage: (this.$lang && this.$lang.bonus_unavailable_backend) || BONUS_BACKEND_UNAVAILABLE_MESSAGE
    }
    const fallbackBonusData = [
      // {
      //   img: require('@/assets/img/bonus/bonus12.png'),
      //   img2: require('@/assets/img/share/total_recharge.png'),
      //   name: this.$lang.common_txt20
      // },
      {
        ...fallbackUnavailable,
        routeKey: 'luckyRoulette',
        activityKeys: ['lucky', 'roulette', 'wheel', 'turntable', '转盘', '充值转盘'],
        img: require('@/assets/img/bonus/bonus2.png'),
        img2: require('@/assets/img/share/wheelof_fortune.png'),
        name: this.$lang.common_txt16,
        tex1: this.$lang.common_txt230,
        text2: this.$lang.common_txt231
      },
      {
        ...fallbackUnavailable,
        routeKey: 'firstRecharge',
        activityKeys: ['first', 'recharge', 'deposit', '首充', '首次', '新手大礼包'],
        img: require('@/assets/img/bonus/bonus3.png'),
        img2: require('@/assets/img/share/recharge_bargain_sales.png'),
        name: this.$lang.common_txt11,
        tex1: this.$lang.common_txt238,
        text2: this.$lang.common_txt239
      },
      {
        ...fallbackUnavailable,
        routeKey: 'referFriend',
        activityKeys: ['refer', 'friend', 'invite', 'treasure', '邀请', '好友', '宝箱'],
        img: require('@/assets/img/bonus/bonus4.png'),
        img2: require('@/assets/img/share/box.png'),
        name: this.$lang.common_txt10,
        tex1: this.$lang.common_txt232,
        text2: this.$lang.common_txt233
      },
      {
        ...fallbackUnavailable,
        routeKey: 'cashBack',
        activityKeys: ['cash', 'back', 'rebate', 'relief', '救助', '返水', '返利'],
        img: require('@/assets/img/bonus/bonus5.png'),
        img2: require('@/assets/img/share/game_benefit.png'),
        name: this.$lang.common_txt15,
        tex1: this.$lang.common_txt228,
        text2: this.$lang.common_txt229
      },
      {
        ...fallbackUnavailable,
        routeKey: 'teamRebates',
        activityKeys: ['team', 'rebate', 'commission', '团队', '返佣', '佣金'],
        img: require('@/assets/img/bonus/bonus6.png'),
        img2: require('@/assets/img/share/global_wash_chip.png'),
        name: this.$lang.common_txt12,
        tex1: this.$lang.common_txt240,
        text2: this.$lang.common_txt241
      },
      {
        ...fallbackUnavailable,
        routeKey: 'redPacket',
        activityKeys: ['red', 'packet', 'envelope', '红包', '红包雨'],
        img: require('@/assets/img/bonus/bonus7.png'),
        img2: require('@/assets/img/share/red_envelope_rain.png'),
        name: this.$lang.common_txt13,
        tex1: this.$lang.common_txt236,
        text2: this.$lang.common_txt237
      },
      {
        ...fallbackUnavailable,
        routeKey: 'share',
        activityKeys: ['share', 'agent', 'commission', '分享', '代理'],
        img: require('@/assets/img/bonus/bonus8.png'),
        img2: require('@/assets/img/share/agent_commission.png'),
        name: this.$lang.common_txt17,
        tex1: this.$lang.common_txt242,
        text2: this.$lang.common_txt243
      },
      {
        ...fallbackUnavailable,
        routeKey: 'signIn',
        activityKeys: ['sign', 'signin', 'check', '签到'],
        img: require('@/assets/img/bonus/bonus10.png'),
        img2: require('@/assets/img/share/user_rank.png'),
        name: this.$lang.common_txt18,
        tex1: this.$lang.common_txt234,
        text2: this.$lang.common_txt235
      },
      {
        ...fallbackUnavailable,
        routeKey: 'vipSignIn',
        activityKeys: ['vip', 'rank', 'birthday', '生日', '等级'],
        img: require('@/assets/img/bonus/bonus9.png'),
        img2: require('@/assets/img/share/mystery.png'),
        name: this.$lang.common_txt19,
        tex1: this.$lang.common_txt244,
        text2: this.$lang.common_txt245
      }
    ]
    fallbackBonusData.forEach(item => {
      item.name = safeString(item.name)
      item.tex1 = safeString(item.tex1)
      item.text2 = safeString(item.text2)
    })
    return {
      showPopup: false,
      showLogin: false,
      fallbackBonusData: fallbackBonusData,
      bonusData: []
    }
  },
  methods: {
    requireLogin() {
      this.showLogin = true
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    async loadBonusActivities() {
      try {
        const data = await GetPromoRule()
        if (!isRewardReadableOkResponse(data) || !isReadableOkResponse(data)) {
          this.showBonusReadFailure(data)
          this.bonusData = this.fallbackBonusData
          return
        }
        const content = responseContent(data) || safeContent({})
        const rules = this.normalizePromoRules(content)
        this.bonusData = this.mergeBonusRules(this.fallbackBonusData, rules)
      } catch (error) {
        if (error && error.status === 'need_login') {
          // 未登录:保留静态橱窗作为拉新钩子,点击卡片再弹登录(不再空白)
          this.bonusData = this.fallbackBonusData
          return
        }
        this.showBonusReadFailure(error)
        this.bonusData = this.fallbackBonusData
      }
    },
    showBonusReadFailure(error) {
      if (!this.$toast) return
      if (isBonusReadUnavailable(error)) return
      this.$toast({
        message: promoFailureMessage(
          error,
          (this.$lang && this.$lang.bonus_unavailable_backend) || BONUS_ROUTE_UNAVAILABLE_MESSAGE
        ),
        icon: 'cross'
      })
    },
    normalizePromoRules(content) {
      return collectPromoRules(content)
        .map(rule => this.normalizePromoRule(rule))
        .filter(rule => Object.keys(rule).length > 0)
    },
    normalizePromoRule(rule) {
      const item = safeObject(rule)
      const hiddenByDelete = [item.deleteFlag, item.delete_flag].some(isHiddenPromoMarker)
      const hiddenByShow = [item.showFlag, item.show_flag].some(isShowBlocked)
      const hiddenByUnavailableMarker = [
        item.mock,
        item.mockMode,
        item.mock_mode,
        item.mockFallback,
        item.mock_fallback,
        item.stub,
        item.fallback,
        item.fallbackUsed,
        item.fallback_used,
        item.dataUnavailable,
        item.data_unavailable,
        item.readOnly,
        item.readonly,
        item.read_only,
        item.readOnlyMode,
        item.read_only_mode,
        item.readOnlyQuery,
        item.read_only_query,
        item.readOnlyAction,
        item.read_only_action,
        item.readFailure,
        item.read_failure,
        item.readFailed,
        item.read_failed,
        item.readUnavailable,
        item.read_unavailable,
        item.missingTable,
        item.missing_table,
        item.missingColumn,
        item.missing_column,
        item.unimplemented,
        item.notImplemented,
        item.not_implemented,
        item.notSupported,
        item.not_supported,
        item.unsupported,
        item.blocked,
        item.backendBlocked,
        item.backend_blocked,
        item.backendFailure,
        item.backend_failure,
        item.technicalMarker,
        item.technical_marker,
        item.writeBlocked,
        item.write_blocked
      ].some(isHiddenPromoMarker) || [
        item.status,
        item.state,
        item.result,
        item.code,
        item.errorCode
      ].some(isUnavailablePromoToken)
      return {
        ...item,
        visible: hiddenByDelete || hiddenByShow || hiddenByUnavailableMarker ? false : item.visible
      }
    },
    mergeBonusRules(items, rules) {
      // fail-open:营销橱窗常驻 —— 没匹配规则/被显式隐藏的活动降级为只读橱窗卡片(仍渲染),
      // 不再整张丢弃;只有后端规则匹配且可见的活动才升级为可点击进入。
      const safeRules = Array.isArray(rules) ? rules : []
      return items.map(item => {
        const rule = safeRules.find(rule => rule.visible !== false && this.matchesActivityRule(item, rule))
        if (!rule || isActivityVisible(rule, { defaultVisible: true }) === false) return item
        return {
          ...item,
          rule,
          readOnly: false,
          unavailableReason: '',
          unavailableMessage: '',
          visible: true
        }
      })
    },
    matchesActivityRule(item, rule) {
      const text = [
        rule.activityType,
        rule.activity_type,
        rule.actTypeKey,
        rule.act_type_key,
        rule.promoType,
        rule.promo_type,
        rule.promoDetail,
        rule.promo_detail,
        rule.type,
        rule.code,
        rule.ruleCode,
        rule.rule_code,
        rule.name,
        rule.title,
        rule.descr,
        rule.description
      ].map(safeString).join(' ').toLowerCase()
      return safeArray(item.activityKeys).some(key => text.includes(safeString(key).toLowerCase()))
    },
    isBonusActionUnavailable(item) {
      if (!item || !item.rule) return true
      return [item, item.rule].some(source => [
        source.readOnly,
        source.readonly,
        source.read_only,
        source.readOnlyMode,
        source.read_only_mode,
        source.readOnlyQuery,
        source.read_only_query,
        source.readOnlyAction,
        source.read_only_action,
        source.readFailure,
        source.read_failure,
        source.readFailed,
        source.read_failed,
        source.readUnavailable,
        source.read_unavailable,
        source.missingTable,
        source.missing_table,
        source.missingColumn,
        source.missing_column,
        source.dataUnavailable,
        source.data_unavailable,
        source.mock,
        source.mockMode,
        source.mock_mode,
        source.mockFallback,
        source.mock_fallback,
        source.stub,
        source.fallback,
        source.fallbackUsed,
        source.fallback_used,
        source.unimplemented,
        source.notImplemented,
        source.not_implemented,
        source.notSupported,
        source.not_supported,
        source.unsupported,
        source.blocked,
        source.backendBlocked,
        source.backend_blocked,
        source.backendFailure,
        source.backend_failure,
        source.technicalMarker,
        source.technical_marker,
        source.writeBlocked,
        source.write_blocked
      ].some(isHiddenPromoMarker) || [
        source.status,
        source.state,
        source.result,
        source.code,
        source.errorCode
      ].some(isUnavailablePromoToken)) || !!item.unavailableReason
    },
    bonusUnavailableMessage(item) {
      return (item && (item.unavailableMessage || item.readOnlyMessage || item.rewardMessage)) ||
        (this.$lang && this.$lang.bonus_unavailable_backend) ||
        BONUS_ROUTE_UNAVAILABLE_MESSAGE
    },
    showBonusUnavailable(item) {
      if (this.$toast) {
        this.$toast({
          message: this.bonusUnavailableMessage(item),
          icon: 'cross'
        })
      }
    },
    safeBonusRoute(routeKey) {
      if (routeKey === 'firstRecharge') return '/activityFistRecharge'
      if (routeKey === 'referFriend') return '/referFriend'
      if (routeKey === 'cashBack') return '/cashBack'
      if (routeKey === 'teamRebates') return '/teamRebates'
      if (routeKey === 'redPacket') return '/redPacket'
      if (routeKey === 'share') return '/share'
      if (routeKey === 'signIn') return '/signIn'
      if (routeKey === 'vipSignIn') return '/vipSignIn'
      return ''
    },
    scrollBonusTop() {
      const target = getBonusAnchorElement()
      if (!target) return
      try {
        target.scrollIntoView({
          behavior: 'auto',
          block: 'start',
          inline: 'nearest'
        })
      } catch (e) {
        // Ignore scroll failures in restricted browser shells.
      }
    },
    goDetail(i) {
      const item = this.bonusData[i]
      if (!item) return
      // fail-open:未登录优先引导登录(营销橱窗的拉新钩子),不再因 readOnly 提前拦成"不可用"
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (this.isBonusActionUnavailable(item)) {
        this.showBonusUnavailable(item)
        return
      }
      const routeKey = item.routeKey
      if (routeKey === 'luckyRoulette') {
        this.scrollBonusTop()
        this.showPopup = true
        return
      }
      const route = this.safeBonusRoute(routeKey)
      if (route) {
        this.scrollBonusTop()
        this.$jumpTo(route)
        return
      }
      this.showBonusUnavailable(item)
    }
  },
  mounted() {
    // fail-open:先渲染静态营销橱窗(8 大福利常驻),再用后端规则增强;读失败/未登录都不再空白。
    this.bonusData = this.fallbackBonusData
    this.loadBonusActivities()
  }
}
</script>
<style lang="less" scoped>
.content {
  // background: @background-color;
  padding-top: 20px;
}
.content-info {
  width: 100%;
  border-radius: 10px;
}
.popup-button1 {
  color: #000000;
  border-radius: 10px; /* 圆角 */
  font-weight: bold;
  margin-top: 135px;
  margin-left: 20px;
  width: 120px;
  height: 35px;
  background: @info-color;
  border: none;
}

.content-info2--img {
  background-image: url('../../assets/img/bonus/invite_friends.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 100%; /* 或者指定具体的宽度 */
  height: 150px;
  border-radius: 13px 13px 0 0;
  margin-bottom: 10px;
}
</style>
